import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { useLocation } from "react-router-dom";
// import WhatsAppAPI from "../../api/WhatsAppAPI";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SparkApi from "../../../api/SparkApi";

const CreateAddon = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [addon, setAddon] = useState(location.state ? location.state : {});

  console.log("addon", addon);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "features") {
      setAddon({
        ...addon,
        [name]: value.split(",").map((f) => f.trim()),
      });
    } else if (
      ["unit", "monthly", "quarterly", "half_yearly", "yearly"].includes(name)
    ) {
      // Restrict these fields to 6 digits
      const sanitizedValue = value.replace(/[^0-9]/g, "").slice(0, 6);
      setAddon({
        ...addon,
        [name]: sanitizedValue,
      });
    } else {
      setAddon({
        ...addon,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let result = {};
    const addonPayload = {
      ...addon,
      pricing: [
        { billing_cycle: "monthly", price_per_unit: addon.monthly },
        { billing_cycle: "quarterly", price_per_unit: addon.quarterly },
        { billing_cycle: "half_yearly", price_per_unit: addon.half_yearly },
        { billing_cycle: "yearly", price_per_unit: addon.yearly },
      ],
    };

    if (addon.id) {
      console.log("addonPayload", addonPayload);
      result = await SparkApi.updateAddon({ ...addonPayload, id: addon.id });
      if (result.errors) {
        toast.error(`${result.errors}`);
      } else {
        toast.success("Record updated successfully");
        navigate(`/addon`, { state: addon });
      }
    } else {
      result = await SparkApi.createAddon(addonPayload);
      if (result.errors) {
        toast.error(`${result.errors}`);
      } else {
        toast.success("Record saved successfully");
        navigate(`/addon`, { state: result });
      }
    }
  };

  const isFormValid =
    addon.name?.trim() &&
    addon.unit?.trim() &&
    ["monthly", "quarterly", "half_yearly", "yearly"].every(
      (key) => addon[key] !== undefined && addon[key] !== ""
    );
  // &&
  // Array.isArray(addon.features) &&
  // addon.features.length > 0;

  const handleCancel = () => {
    navigate(`/addon`, { state: addon });
  };
  return (
    <>
      <Container className="mt-5">
        <Row className="g-0 mx-5 text-center ">
          <Col lg={12} xs={12} sm={12}>
            <div
              className=" text-center p-2"
              style={{
                height: "40px",
                backgroundColor: "#ffffff",
                borderRadius: "5px",
              }}
            >
              <span
                className="fw-semibold p-1"
                style={{ color: "#605C68", fontSize: "large" }}
              >
                {addon.id ? <>Edit Addon</> : <>Add Addon</>}
              </span>
            </div>
          </Col>
        </Row>
      </Container>
      <Container className="mt-1 mb-5">
        <Row className="mx-5 my-4 g-0">
          <Col lg={12} sm={12} xs={12} className="mb-2">
            <Card className="h-100" style={{ border: "none" }}>
              <Card.Body>
                <Row className="mb-4 mt-5">
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">Name</Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        required={true}
                        type="text"
                        name="name"
                        placeholder="Enter Name"
                        value={addon.name}
                        onChange={(e) => handleChange(e)}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">Unit</Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        type="number"
                        name="unit"
                        required
                        placeholder="Enter Unit"
                        value={addon.unit}
                        onChange={(e) => handleChange(e)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="mx-3" controlId="formCampaignName">
                      <Form.Label className="form-view-label">
                        Monthly Price
                      </Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        type="number"
                        name="monthly"
                        required
                        placeholder="Enter Monthly Price"
                        value={addon.monthly}
                        onChange={(e) => handleChange(e)}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="mx-3" controlId="formCampaignName">
                      <Form.Label className="form-view-label">
                        Quarterly Price
                      </Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        type="number"
                        name="quarterly"
                        required
                        placeholder="Enter Quarterly Price"
                        value={addon.quarterly}
                        onChange={(e) => handleChange(e)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="mx-3" controlId="formCampaignName">
                      <Form.Label className="form-view-label">
                        Half Yearly Price
                      </Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        type="number"
                        name="half_yearly"
                        required
                        placeholder="Enter Half Yearly Price"
                        value={addon.half_yearly}
                        onChange={(e) => handleChange(e)}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group className="mx-3" controlId="formCampaignName">
                      <Form.Label className="form-view-label">
                        Yearly Price
                      </Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        type="number"
                        name="yearly"
                        required
                        placeholder="Enter Yearly Price"
                        value={addon.yearly}
                        onChange={(e) => handleChange(e)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="g-0 mb-2">
                  <Col lg={12} sm={12} xs={12} className="text-end mt-2">
                    <Button
                      className="mx-2"
                      variant="light"
                      onClick={handleCancel}
                    >
                      Back
                    </Button>
                    <Button
                      className="btn btn-outline-primary mx-2"

                      //     variant="outline-secondary"
                      disabled={!isFormValid}
                      onClick={handleSubmit}
                      type="button"
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </>
  );
};
export default CreateAddon;
